import logToCartAttribute from "./logToCartAttribute";

export default function getSellingPlanId(node) {
  try {
    if (!node) return '';

    let quantityAvailable = node.quantityAvailable;

    if (quantityAvailable > 0 || !node.availableForSale) return '';

    const sellingPlanId = 'edges' in node.sellingPlanAllocations ? node.sellingPlanAllocations.edges[0].node.sellingPlan.id.replace('gid://shopify/SellingPlan/', '') : node.sellingPlanAllocations[0].sellingPlan.id.replace('gid://shopify/SellingPlan/', '');

    return sellingPlanId;
  } catch (error) {
    console.warn("Error finding selling plan for", node, error);
    logToCartAttribute('_sellingPlanErrorLog', ["Error finding selling plan for", node, error.toString()]);
    return '';
  }
}
